import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex border-b border-gray-700 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-tab', 'products'))),
      class: _normalizeClass(["px-6 py-3 text-sm font-medium transition-colors relative -mb-px", [
        _ctx.activeTab === 'products'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]])
    }, " Oglasi ", 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-tab', 'ratings'))),
      class: _normalizeClass(["px-6 py-3 text-sm font-medium transition-colors relative -mb-px", [
        _ctx.activeTab === 'ratings'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]])
    }, " Ocene ", 2)
  ]))
}